/**
 * Fishermans — Order bump.
 *
 * Raiz propria [data-fm-bump] — NAO usar [data-fm-v2-pdp].
 *
 * Fluxo aprovado pelo Jorge: CONSTRUCAO -> CAMUFLAGEM -> LIBRAS.
 * A camuflagem vem antes das libras de proposito: a disponibilidade muda entre
 * os produtos irmaos (ex.: 70lb esgotada na X8 Oceanica, 80lb na X4 Amazonica),
 * entao a lista de libras so pode ser montada depois de saber a camuflagem.
 *
 * Os dados vem de um <script type="application/json"> renderizado pelo Liquid,
 * ja filtrado em 300m e sem as bitolas que quebram o preco plano.
 */
(function () {
  /* Voltou de um reload feito pelo fallback do carrinho? Abre o mini cart. */
  try {
    if (sessionStorage.getItem("fm_open_cart")) {
      sessionStorage.removeItem("fm_open_cart");
      setTimeout(function () {
        var d = document.querySelector("cart-drawer");
        if (d && typeof d.open === "function") d.open();
      }, 300);
    }
  } catch (e) {}

  document.querySelectorAll("[data-fm-bump]").forEach(function (root) {
    var dataEl = root.querySelector("[data-fm-bump-data]");
    if (!dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selBuild = root.querySelector("[data-fm-bump-build]");
    var selCamo = root.querySelector("[data-fm-bump-camo]");
    var selLb = root.querySelector("[data-fm-bump-lb]");
    var btn = root.querySelector("[data-fm-bump-add]");
    var elName = root.querySelector("[data-fm-bump-name]");
    var elPrice = root.querySelector("[data-fm-bump-price]");
    var elCompare = root.querySelector("[data-fm-bump-compare]");
    var elSave = root.querySelector("[data-fm-bump-save]");
    var elImg = root.querySelector("[data-fm-bump-img]");
    var elMsg = root.querySelector("[data-fm-bump-msg]");
    if (!selBuild || !selCamo || !selLb || !btn) return;

    function money(cents) {
      return "R$ " + (cents / 100).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/, ".");
    }

    function currentGroup() {
      var g = DATA[selBuild.value];
      return g ? g[selCamo.value] : null;
    }

    function fillLbs() {
      var g = currentGroup();
      selLb.innerHTML = "";
      if (!g || !g.variants.length) { selLb.disabled = true; return; }
      selLb.disabled = false;

      var keep = selLb.dataset.last;
      g.variants.forEach(function (v) {
        var o = document.createElement("option");
        o.value = String(v.id);
        o.textContent = v.lb + " · " + v.mm + (v.available ? "" : " — esgotado");
        o.disabled = !v.available;
        selLb.appendChild(o);
      });
      // preserva a libra escolhida se ela existir e estiver disponivel aqui
      var byLb = g.variants.find(function (v) { return v.lb === keep && v.available; });
      var first = g.variants.find(function (v) { return v.available; });
      var pick = byLb || first;
      if (pick) selLb.value = String(pick.id);
    }

    function render() {
      var g = currentGroup();
      if (!g) return;
      var v = g.variants.find(function (x) { return String(x.id) === selLb.value; });

      if (elName) elName.textContent = g.title;
      if (elImg && g.image) { elImg.src = g.image; elImg.alt = g.title; }

      if (v) {
        selLb.dataset.last = v.lb;
        if (elPrice) elPrice.textContent = money(v.price);
        if (elCompare) {
          if (v.compare > v.price) {
            elCompare.textContent = money(v.compare);
            elCompare.hidden = false;
          } else { elCompare.hidden = true; }
        }
        if (elSave) {
          if (v.compare > v.price) {
            elSave.textContent = "Economize " + Math.round((1 - v.price / v.compare) * 100) + "%";
            elSave.hidden = false;
          } else { elSave.hidden = true; }
        }
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.label || "Adicionar" : "Esgotado";
      } else {
        btn.disabled = true;
      }
    }

    selBuild.addEventListener("change", function () { fillLbs(); render(); });
    selCamo.addEventListener("change", function () { fillLbs(); render(); });
    selLb.addEventListener("change", render);

    btn.addEventListener("click", function () {
      var id = selLb.value;
      if (!id) return;
      btn.disabled = true;
      var was = btn.textContent;
      btn.textContent = "Adicionando...";

      /* Section Rendering API: sem isso o drawer abre com o HTML velho em cache
         e mostra "seu carrinho esta vazio" mesmo com o item ja adicionado.
         Mesmo tratamento (e mesmo fallback) do fishermans-v3-pdp.js. */
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: "cart-drawer,cart-icon-bubble,cart-notification",
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error("cart");
          return r.json();
        })
        .then(function (data) {
          var refreshed = false;
          if (data && data.sections) {
            Object.keys(data.sections).forEach(function (sid) {
              if (injectSection(sid, data.sections[sid])) refreshed = true;
            });
          }
          if (!refreshed) {
            /* Section Rendering nao pegou nesse tema -> recarrega e abre o carrinho */
            try { sessionStorage.setItem("fm_open_cart", "1"); } catch (e) {}
            window.location.reload();
            return;
          }
          btn.textContent = "Adicionado ✓";
          if (elMsg) elMsg.hidden = false;
          openMiniCart();
          setTimeout(function () { btn.textContent = was; btn.disabled = false; }, 2500);
        })
        .catch(function () {
          btn.textContent = "Tente de novo";
          btn.disabled = false;
        });
    });

    /* Injeta o HTML devolvido pelo Section Rendering API no lugar certo. */
    function injectSection(sectionId, html) {
      if (!html) return false;
      var wrapper = document.getElementById("shopify-section-" + sectionId);
      if (wrapper) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.getElementById("shopify-section-" + sectionId);
        wrapper.innerHTML = fresh ? fresh.innerHTML : html;
        return true;
      }
      var selectors = [sectionId, "#" + sectionId, "[data-section-id='" + sectionId + "']"];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el) {
          var d2 = new DOMParser().parseFromString(html, "text/html");
          var f2 = d2.querySelector(selectors[i]);
          el.innerHTML = f2 ? f2.innerHTML : html;
          return true;
        }
      }
      return false;
    }

    /* Abre o mini cart do tema (mesma logica da v3). */
    function openMiniCart() {
      var drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.open === "function") { drawer.open(); return; }
      var notif = document.querySelector("cart-notification");
      if (notif && typeof notif.open === "function") { notif.open(); return; }
      var trigger = document.querySelector(
        "[data-cart-drawer-toggle], [aria-controls='cart-drawer'], .js-drawer-open-cart, .header__icon--cart"
      );
      if (trigger) { trigger.click(); return; }
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }

    fillLbs();
    render();
  });
})();
